import React, { useEffect, useContext, useMemo } from 'react';
import Cookies from 'js-cookie';
import classes from './HomePage.module.css';
import { useNavigate } from 'react-router-dom';
import { setuserlevellimtApi } from '../http/http';

import LanguageSelector from './LanguageSelector';
import { LanguageContext } from './LanguageContext';
import Loading from '../components/Loading';
import { baseImageUrl } from '../utils/constants';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLevels } from '../store/slices/levelsSlice';
import { fetchUserDetails } from '../store/slices/userSlice';
import { fetchUserHistory } from '../store/slices/userHistorySlice';
import { HOME, COMMON, pageT } from '../utils/i18n';

const DEFAULT_PROFILE_IMG =
  'https://tse4.mm.bing.net/th/id/OIP.eU8MYLNMRBadK-YgTT6FJQHaHw?pid=Api&P=0&h=180';

const computeLevelHistory = (data) => {
  const list = Array.isArray(data) ? data : [];
  const todayData = list.filter((item) =>
    moment(item.earned_date).isSame(moment(), 'day')
  );

  if (todayData.length > 0) {
    if (list?.length % 3 === 0) {
      return todayData?.map((i) => i?.level_no);
    }
    return [...todayData?.map((i) => i?.level_no), (list?.length ?? 0) + 1];
  }

  return [...(list?.map(() => 0) ?? []), (list?.length ?? 0) + 1];
};

const HomePage = () => {
  const navigate = useNavigate();
  const { lang } = useContext(LanguageContext);
  const t = pageT(lang, HOME);
  const c = pageT(lang, COMMON);

  const dispatch = useDispatch();

  const userDetails = useSelector((state) => state.user.details);
  const levels = useSelector((state) => state.levels.levels);
  const historyData = useSelector((state) => state.userHistory.history);

  const levelsStatus = useSelector((state) => state.levels.status);
  const userDetailsStatus = useSelector((state) => state.user.detailsStatus);
  const userHistoryStatus = useSelector((state) => state.userHistory.status);

  const loading =
    levelsStatus === 'loading' ||
    userDetailsStatus === 'loading' ||
    userHistoryStatus === 'loading';

  const profileImg = userDetails?.profile_url
    ? `${baseImageUrl}${userDetails.profile_url}`
    : DEFAULT_PROFILE_IMG;

  const levelHistory = useMemo(
    () => computeLevelHistory(historyData),
    [historyData]
  );

  const openLevel = async (levelNo) => {
    try {
      if (isUnlocked(levelNo)) {
        const token = Cookies.get('token');
        const limitRes = await setuserlevellimtApi(token);

        if (limitRes.data.success === false) {
          alert(c.dailyLimit);
          navigate('/home');
          return;
        }

        navigate(`/levelpage/${levelNo}`);
      }
    } catch (err) {
      console.log('Error fetching level data', err);
    }
  };

  useEffect(() => {
    const token = Cookies.get('token');
    if (!token) window.location.href = '/login';

    dispatch(fetchUserDetails(token));
    dispatch(fetchLevels(token));
    dispatch(fetchUserHistory(token));
  }, [dispatch, navigate]);

  // const isUnlocked = (levelNo) => levelNo == completedLevel;
  const isUnlocked = (levelNo) => levelHistory?.includes(levelNo);

  return (
    <div className={classes.levels_container}>
      {loading && <Loading />}

      {!loading && (
        <>
          <div className={classes.topBar}>
            <div
              className={classes.profileBox}
              onClick={() => navigate('/account')}
            >
              <img
                src={profileImg}
                alt="profile"
                className={classes.profileImg}
              />
            </div>

            <div className={classes.languageBox}>
              <LanguageSelector />
            </div>
          </div>

          <h1 className={classes.levels_title}>{t.title}</h1>

          <div className={classes.levels_grid}>
            {levels.map((level) => (
              <div
                key={level.id}
                className={classes.envelope}
                onClick={() =>
                  isUnlocked(level.level_no) && openLevel(level.level_no)
                }
                style={{
                  cursor: isUnlocked(level.level_no)
                    ? 'pointer'
                    : 'not-allowed',
                  opacity: isUnlocked(level.level_no) ? 1 : 0.5,
                }}
              >
                <div
                  className={`${classes.envelope_top} ${
                    isUnlocked(level.level_no) ? classes.openFlap : ''
                  }`}
                ></div>

                <div className={classes.envelope_body}>
                  {isUnlocked(level.level_no) ? (
                    <div className={classes.chit}>{level.level_no}</div>
                  ) : (
                    <div className={classes.lock}>🔒</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {/* background always visible */}
      <div className={classes.floating_shapes}>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default HomePage;
